export default "__VITE_ASSET__02fa224a__"